<template>
    <editor-content :editor="editor" />
</template>

<script>
import { EditorContent } from '@tiptap/vue-2'
export default {
  name: "TextEditor",
  props: {
    editor: {
      type: Object,
      default: null
    },
  },
  components: {
    EditorContent,
  },
}
</script>

<style lang="scss">
.tippy-box[data-theme~='suggestion'] {
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  font-weight: 700!important;
  color: rgba(0, 0, 0, 0.87);

  span.white--text {
    color: white;
    font-weight: 400!important;
  }
}
</style>
